import { useTranslation } from 'next-i18next';

export const ReadingTime = ({ minutes }: { minutes: string }) => {
  const { t } = useTranslation('common');

  if (!minutes.trim()) return null;

  return t('readingTime', { minutes });
};
